import { getType } from 'typesafe-actions'
import { cloneDeep } from 'lodash'

import * as actions from './actions'
import { StoreState, ReportAction } from './types'
import produce from 'immer'
import parseErrorMessage from 'utils/parseErrorMessage'
import { Event } from '../../types/event'

const initEvent = {
  IsLoading: false,
  MessageSuccess: undefined,
  SubmitError: undefined,
  SubmitSuccess: false,
  SubmitType: undefined,
} as Event

const initialState: StoreState = {
  dataList: {
    Total: 0,
    List: [],
  },
  mainconList: [],
  requestHistoryList: [],
  event: cloneDeep(initEvent),
}

export default function(
  state: StoreState = initialState,
  action: ReportAction
): StoreState {
  return produce(state, draft => {
    switch (action.type) {
      case getType(actions.getRequestHistoryAction.request):
        draft.event = cloneDeep(initEvent)
        draft.event.IsLoading = true
        draft.requestHistoryList = []

        break
      case getType(actions.getRequestHistoryAction.success):
        draft.event.IsLoading = false
        draft.requestHistoryList = action.payload.ResponseData

        break
      case getType(actions.getDataListAction.request):
        draft.event = cloneDeep(initEvent)
        draft.event.IsLoading = true
        draft.dataList = {
          Total: 0,
          List: [],
        }

        break
      case getType(actions.getDataListAction.success):
        draft.event.IsLoading = false
        draft.dataList = action.payload.ResponseData

        break

      case getType(actions.updateDataAction.request):
        draft.event = cloneDeep(initEvent)
        draft.event.IsLoading = true
        break

      case getType(actions.updateDataAction.success):
        draft.event.IsLoading = false
        draft.event.SubmitError = undefined
        draft.event.SubmitSuccess = true
        draft.event.MessageSuccess = 'ทำรายการสำเร็จ'
        break

      case getType(actions.getMainConListAction.request):
        draft.event = cloneDeep(initEvent)
        draft.event.IsLoading = true
        draft.mainconList = []

        break
      case getType(actions.getMainConListAction.success):
        draft.event.IsLoading = false
        draft.mainconList = action.payload.ResponseData.List
        break

      case getType(actions.updateDataAction.failure):
      case getType(actions.getDataListAction.failure):
      case getType(actions.getMainConListAction.failure):
      case getType(actions.getRequestHistoryAction.failure):
        draft.event.IsLoading = false
        draft.event.SubmitError = parseErrorMessage(action.payload)
        break

      case getType(actions.resetEvent):
        draft.event = cloneDeep(initEvent)
        break

      default:
        return state
    }
  })
}
